import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const TextDate = styled(Typography)({
  fontFamily: 'Quicksand',
  fontWeight: 500,
  fontSize: '16px',
  color: '#657787',
})
